import React from "react";
import ReactDOM from "react-dom";
import {Provider} from './components/utils.jsx';
import poly from "poly-js-utils";
poly.KalturaHelpers.init();

import css from "./common/dynamic-css-loader.js";
css.loadDynamicCss();

import HomePage from "./components/home_page";

ReactDOM.render(
    <Provider JSContext={window.JSContext}>
        <HomePage />
    </Provider>,
    document.getElementById('app')
);



// WEBPACK FOOTER //
// ./scripts.js